if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onSliderScroll = this.onSliderScroll.bind(this);

      this.slider = this.querySelector('.product-media-modal__slider') || this.querySelector('.product-media-modal__content');
      this.prevButton = this.querySelector('.product-media-modal__nav--prev');
      this.nextButton = this.querySelector('.product-media-modal__nav--next');

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      if (this.slider) this.slider.addEventListener('scroll', this.onSliderScroll, { passive: true });
      this.addEventListener('keydown', this.onKeyDown);
    }

    get slides() {
      if (!this.slider) return [];
      return Array.from(this.slider.querySelectorAll('.product-media-modal__slide'));
    }

    get activeIndex() {
      return this.slides.findIndex((slide) => slide.classList.contains('active'));
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.preloadSlideImages();
      this.showActiveMedia();
      this.updateNavButtons();
    }

    preloadSlideImages() {
      if (!this.slider) return;
      this.slider.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
      });
    }

    findSlideByMediaId(mediaId) {
      if (!mediaId) return null;
      const id = String(mediaId);
      return this.slides.find((slide) => slide.getAttribute('data-media-id') === id) || null;
    }

    showActiveMedia() {
      const mediaId = this.openedBy.getAttribute('data-media-id');
      this.slides.forEach((slide) => slide.classList.remove('active'));

      const activeSlide = this.findSlideByMediaId(mediaId) || this.slides[0];
      if (!activeSlide) return;

      activeSlide.classList.add('active');
      this.loadSlideMedia(activeSlide);
      this.scrollToSlide(activeSlide, 'auto');
      this.updateNavButtons();
    }

    loadSlideMedia(slide) {
      const deferredMedia = slide.matches('deferred-media, product-model')
        ? slide
        : slide.querySelector('deferred-media, product-model');

      if (!deferredMedia || deferredMedia.nodeName !== 'DEFERRED-MEDIA') return;

      const activeMediaTemplate = deferredMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      if (activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
        deferredMedia.loadContent();
      }
    }

    scrollToSlide(slide, behavior) {
      if (!this.slider || !slide) return;
      const index = this.slides.indexOf(slide);
      if (index === -1) return;
      this.slider.scrollTo({
        left: index * this.slider.clientWidth,
        behavior: behavior || 'smooth'
      });
    }

    goToIndex(index) {
      const slide = this.slides[index];
      if (!slide) return;

      this.slides.forEach((item) => item.classList.remove('active'));
      slide.classList.add('active');
      this.loadSlideMedia(slide);
      this.scrollToSlide(slide, 'smooth');
      this.updateNavButtons();
    }

    onPrevClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const index = this.activeIndex;
      if (index > 0) this.goToIndex(index - 1);
    }

    onNextClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const index = this.activeIndex;
      if (index < this.slides.length - 1) this.goToIndex(index < 0 ? 0 : index + 1);
    }

    onKeyDown(event) {
      if (!this.hasAttribute('open')) return;
      if (event.key === 'ArrowLeft') this.onPrevClick(event);
      if (event.key === 'ArrowRight') this.onNextClick(event);
    }

    onSliderScroll() {
      if (!this.slider || !this.slides.length) return;

      const closestIndex = Math.min(
        Math.max(Math.round(this.slider.scrollLeft / this.slider.clientWidth), 0),
        this.slides.length - 1
      );

      if (closestIndex === this.activeIndex) return;

      this.slides.forEach((slide) => slide.classList.remove('active'));
      this.slides[closestIndex].classList.add('active');
      this.loadSlideMedia(this.slides[closestIndex]);
      this.updateNavButtons();
    }

    updateNavButtons() {
      const index = this.activeIndex;
      const total = this.slides.length;
      const hideNav = total <= 1;

      if (this.prevButton) {
        this.prevButton.disabled = index <= 0;
        this.prevButton.toggleAttribute('hidden', hideNav);
      }

      if (this.nextButton) {
        this.nextButton.disabled = index >= total - 1;
        this.nextButton.toggleAttribute('hidden', hideNav);
      }
    }
  });
}
